import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col" }
const _hoisted_3 = { for: "email" }
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col" }
const _hoisted_6 = { class: "p-field p-col" }
const _hoisted_7 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_8 = { class: "p-field p-col" }
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = { class: "p-field p-col" }
const _hoisted_11 = { class: "p-field p-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state === 'default')
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "p-d-flex p-jc-center"
        }, {
          title: _withCtx(() => [
            _createVNode("h3", null, _toDisplayString(_ctx.$t('login.resetpw')), 1)
          ]),
          content: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login.username')), 1),
                _createVNode(_component_InputText, {
                  id: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                  type: "email",
                  placeholder: "hans.pilz@example.ch"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  class: "p-button-info",
                  onClick: _ctx.toLogin,
                  label: _ctx.$t('login.back')
                }, null, 8, ["onClick", "label"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Button, {
                  class: "p-button-secondary",
                  disabled: !_ctx.mailValid,
                  onClick: _ctx.resetPw,
                  label: _ctx.$t('login.reset')
                }, null, 8, ["disabled", "onClick", "label"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.state === 'error')
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "p-d-flex p-jc-center"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Message, {
              severity: "error",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.token_sent_error')), 1)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  class: "p-button-info",
                  onClick: _ctx.toLogin,
                  label: _ctx.$t('login.back')
                }, null, 8, ["onClick", "label"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.state === 'success')
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 2,
          class: "p-d-flex p-jc-center"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Message, {
              severity: "success",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.token_sent_success')), 1)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  class: "p-button-info",
                  onClick: _ctx.toLogin,
                  label: _ctx.$t('login.back')
                }, null, 8, ["onClick", "label"])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  class: "p-button-danger",
                  onClick: _ctx.toResetPwResetToken,
                  label:  _ctx.$t('login.reset_now')
                }, null, 8, ["onClick", "label"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}